<template>
  <div>
    <el-row class="text-center system-stepcon">
      <el-col :span="14" :offset="5">
        <el-form ref="form" label-width="150px">
          <el-form-item class="text-left system-stepcon-itemswitch" label="是否开启业务分配">
            <el-switch @input="forceInput" v-model="cacheAcd.enableBiz" @change="changeSwitch" :active-value=1 :inactive-value=0 active-color="#337eff" inactive-color="#dcdfe6" :width="50"></el-switch>
            <span class="text system-ml10"><i>*</i> 业务分配如未开启，则所有进线消息全部分配至默认技能组</span>
          </el-form-item>
          <transition>
            <div v-show="cacheAcd.enableBiz===1">
              <el-form-item size="mini" class="text-lef system-stepcon-itemlist" label="业务设置">
              </el-form-item>

              <div v-for="(biz,index) in cacheAcd.acdBizs" :key="biz.id">
                <el-form-item size="medium" :label="'业务'+(index+1)" class="text-left system-stepcon-itemlist">
                  <el-input class="system-mr10" maxlength="12" v-model="biz.bizName" style="width:100px"></el-input>
                    <el-select v-model="biz.skillGroupIds" multiple collapse-tags placeholder="请选择">
                      <el-option
                        v-for="item in storeSkillGroupList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        >
                      </el-option>
                    </el-select>
                  <el-button class="system-ml10" type="info" @click="showTimeDialog(biz)">服务时间设置</el-button>
                  <el-button style="margin-left:10px;" size="medium" @click="deleteBiz(index)" icon="el-icon-minus"></el-button>
                </el-form-item>
              </div>
              <el-dialog title="服务时间" class="text-left dialogServiceTime" :visible.sync="dialogServiceTime" width="480px" center>
                <div class="dialogServiceTime_txt"><span class="text-danger">*</span> 业务时间只可小于策略时间</div>
                <el-form class="formone" ref="form" :model="system_timeForm" label-width="0px">
                  <el-form-item class="system-stepcon-time" label="" size="medium">
                  <el-checkbox class="text-left" v-model="system_timeForm.checked1">
                    <p class="text-left system-stepcon-checktxt">周一</p>
                    <!-- 日期时间框 -->
                    <el-form-item>
                      <el-time-picker style="width:310px;" size="medium" format='HH:mm' value-format="HH:mm" is-range v-model="system_timeForm.startAndEndTime1" range-separator="至"
                                      start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围">
                      </el-time-picker>
                    </el-form-item>
                  </el-checkbox>
                  <el-checkbox class="text-left" v-model="system_timeForm.checked2">
                    <p class="text-left system-stepcon-checktxt">周二</p>
                    <!-- 日期时间框 -->
                    <el-form-item>
                      <el-time-picker size="medium" format='HH:mm' value-format="HH:mm" is-range v-model="system_timeForm.startAndEndTime2" range-separator="至"
                                      start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围">
                      </el-time-picker>
                    </el-form-item>
                  </el-checkbox>
                  <el-checkbox class="text-left" v-model="system_timeForm.checked3">
                    <p class="text-left system-stepcon-checktxt">周三</p>
                    <!-- 日期时间框 -->
                    <el-form-item>
                      <el-time-picker size="medium" format='HH:mm' value-format="HH:mm" is-range v-model="system_timeForm.startAndEndTime3" range-separator="至"
                                      start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围">
                      </el-time-picker>
                    </el-form-item>
                  </el-checkbox>
                  <el-checkbox class="text-left" v-model="system_timeForm.checked4">
                    <p class="text-left system-stepcon-checktxt">周四</p>
                    <!-- 日期时间框 -->
                    <el-form-item>
                      <el-time-picker size="medium" format='HH:mm' value-format="HH:mm" is-range v-model="system_timeForm.startAndEndTime4" range-separator="至"
                                      start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围">
                      </el-time-picker>
                    </el-form-item>
                  </el-checkbox>
                  <el-checkbox class="text-left" v-model="system_timeForm.checked5">
                    <p class="text-left system-stepcon-checktxt">周五</p>
                    <!-- 日期时间框 -->
                    <el-form-item>
                      <el-time-picker size="medium" format='HH:mm' value-format="HH:mm" is-range v-model="system_timeForm.startAndEndTime5" range-separator="至"
                                      start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围">
                      </el-time-picker>
                    </el-form-item>
                  </el-checkbox>
                  <el-checkbox class="text-left" v-model="system_timeForm.checked6">
                    <p class="text-left system-stepcon-checktxt">周六</p>
                    <!-- 日期时间框 -->
                    <el-form-item>
                      <el-time-picker size="medium" format='HH:mm' value-format="HH:mm" is-range v-model="system_timeForm.startAndEndTime6" range-separator="至"
                                      start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围">
                      </el-time-picker>
                    </el-form-item>
                  </el-checkbox>
                  <el-checkbox class="text-left" v-model="system_timeForm.checked7">
                    <p class="text-left system-stepcon-checktxt">周日</p>
                    <!-- 日期时间框 -->
                    <el-form-item>
                      <el-time-picker size="medium" format='HH:mm' value-format="HH:mm" is-range v-model="system_timeForm.startAndEndTime7" range-separator="至"
                                      start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围">
                      </el-time-picker>
                    </el-form-item>
                  </el-checkbox>
                </el-form-item>
                </el-form>
                <el-form ref="form" :model="system_timeForm" label-width="140px">
                  <el-form-item class="text-left" label="法定假日除外">
                    <el-switch v-model="system_timeForm.excludeHoliday" :width="50" :active-value=1 :inactive-value=0  active-color="#337eff" inactive-color="#dcdfe6"></el-switch>
                  </el-form-item>
                  <el-form-item class="text-left" label="非策略时间进线话术">
                    <el-input type="textarea" placeholder="请输入引导话术内容" v-model="system_timeForm.extimeServiceWords"></el-input>
                  </el-form-item>
                  <el-form-item class="text-left" label="非策略时间进线策略">
                    <el-select v-model="system_timeForm.extimeServiceType" placeholder="请选择非策略时间进线策略">
                      <el-option label="机器人服务" :value="0"></el-option>
                      <el-option label="用户留言" :value="1"></el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer" style="text-align:center;">
                  <el-button @click="dialogServiceTime = false">取 消</el-button>
                  <el-button type="primary" @click="comfirmBiz">确 认</el-button>
                </span>
              </el-dialog>
              <el-form-item class="text-left system-stepcon-itemlist" style="margin-bottom:20px">
                <el-button size="medium" :loading="addBizLoadingLing" @click="addBiz" icon="el-icon-plus" class="system-stepcon-itemlistbtn"></el-button>
              </el-form-item>
              <el-form-item class="text-left" label="业务选择错误策略" >
                <el-select v-model="cacheAcd.bizChooseErrType" @input="forceInput" placeholder="请选择业务选择错误策略">
                  <el-option label="重新选择" :value=0></el-option>
                  <el-option label="随机分配业务" :value=1></el-option>
                </el-select>
              </el-form-item>
              <el-form-item size="medium" v-show="cacheAcd.bizChooseErrType===0" class="text-left system-stepcon-itemswitch" label="自动随机分配阈值">
                <el-input-number class="pull-left" v-model="cacheAcd.bizErrTimeThreshold" @input="forceInput" controls-position="right" :min="1" :max="10"></el-input-number>
                <div class="system-stepcon-itemci">次</div>
                <div class="text system-bfb pull-left"><i>*</i>当访客错误选择业务次数达到阈值后，系统将访客随机分派至一个业务中进行接待。</div>
              </el-form-item>
              <el-form-item class="text-left" label="同业务多技能组分配">
                <el-select v-model="cacheAcd.multiSgStrategyId" @input="forceInput"  placeholder="请选择多技能分配策略">
                  <el-option label="随机分配" value="8"></el-option>
                  <el-option label="会话量少优先" value="9"></el-option>
                  <el-option label="会话总时长低优先" value="10"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item size="medium"  class="text-left system-stepcon-itemlist pst" label="工作量重置时间点">
                <el-row style="padding-top:5px" v-for="(item,index) in cacheAcd.acdBizResets" :key="index">
                  <el-time-picker  class="system-stepcon-itemtime system-mr10 pull-left"
                    arrow-control
                    v-model="item.resetTime"
                    format='HH:mm' value-format="HH:mm"
                    placeholder="选择时间">
                  </el-time-picker>
                  <el-button size="medium" @click="index === 0?addResetTime(index):deleteResetTime(index)" :icon="index === 0 ?'el-icon-plus':'el-icon-minus'" class="system-stepcon-itemlistbtn"></el-button>
                </el-row>
                <div style="position:absolute;left:265px;top:10px;color:#999;line-height:24px;" class="dialogServiceTime_txt system-ml10">
                  <span class="text-danger" style="margin-right:5px;">*</span> 重置计算工作量（会话量及会话时长）的时间点
                </div>
              </el-form-item>
            </div>
          </transition>
        </el-form>
      </el-col>
    </el-row>
    <el-row class="text-center system-stepbtn">
    <el-button @click="cancel" class="customer-mr20" size="medium">取 消</el-button>
    <el-button @click="lastStep" size="medium">上一步</el-button>
    <el-button size="medium" @click="nextStep" type="primary">下一步</el-button>
    </el-row>
  </div>
</template>
<script>
import { getRandomUUID } from '@/api/user'
export default {
  name: 'stepTwo',
  data() {
    return {
      curDialogBizId: '',
      addBizLoadingLing: false,
      system_timeForm_clear: {
        checked1: false,
        checked2: false,
        checked3: false,
        checked4: false,
        checked5: false,
        checked6: false,
        checked7: false,
        startAndEndTime1: ['', ''],
        startAndEndTime2: ['', ''],
        startAndEndTime3: ['', ''],
        startAndEndTime4: ['', ''],
        startAndEndTime5: ['', ''],
        startAndEndTime6: ['', ''],
        startAndEndTime7: ['', ''],
        excludeHoliday: 0, // 是否排除法定假日，0：false，1：true
        extimeServiceType: '', // 非策略时间进线策略类型，0：机器人，1：用户留言
        extimeServiceWords: ''// 非策略时间进线话术
      },
      system_timeForm: {
        checked1: true,
        checked2: true,
        checked3: true,
        checked4: true,
        checked5: true,
        checked6: true,
        checked7: true,
        startAndEndTime1: ['00:00', '23:59'],
        startAndEndTime2: ['00:00', '23:59'],
        startAndEndTime3: ['00:00', '23:59'],
        startAndEndTime4: ['00:00', '23:59'],
        startAndEndTime5: ['00:00', '23:59'],
        startAndEndTime6: ['00:00', '23:59'],
        startAndEndTime7: ['00:00', '23:59'],
        excludeHoliday: 0, // 是否排除法定假日，0：false，1：true
        extimeServiceType: 1, // 非策略时间进线策略类型，0：机器人，1：用户留言
        extimeServiceWords: '您好，目前正处于坐席非工作时间，请您在工作时间再与我们联系。'// 非策略时间进线话术
      },

      dialogServiceTime: false,
      isShow: false,

      bizs: [
        {}
      ],
      blankBiz: {
        id: '',
        bizName: '',
        acdId: '',
        excludeHoliday: 0,
        extimeServiceType: null,
        extimeServiceWords: '',
        defaultBiz: 0,
        sysAcdXSkillGroups: null,
        skillGroupIds: [],
        bizTimes: [],
        sysAcdBizQueue: {}
      },
      resetTime: {
        id: '',
        acdId: '',
        resetTime: '00:00'
      }

    }
  },
  computed: {
    storeSkillGroupList() {
      return this.$store.state.user.skillGroupList
    },
    cacheAcd() {
      return this.$store.state.user.acdCache
    },
    acdTimeForm() {
      return this.$store.state.user.acdTimeForm
    }
  },
  methods: {
    forceInput() {
      this.$forceUpdate()// 强制刷新视图，每一个无法输入的input框都需要使用该方法
    },
    showTimeDialog(biz) {
      Object.assign(this.system_timeForm, this.system_timeForm_clear)// 属性置空

      const times = biz.bizTimes
      this.curDialogBizId = biz.id
      this.system_timeForm.excludeHoliday = biz.excludeHoliday
      this.system_timeForm.extimeServiceType = biz.extimeServiceType
      this.system_timeForm.extimeServiceWords = biz.extimeServiceWords
      if (times != null && times.length > 0) {
        times.forEach((v, i) => {
          if (v.startTime && v.endTime) {
            if (v.weekday === 1) {
              this.system_timeForm.checked7 = true
              this.system_timeForm.startAndEndTime7 = [v.startTime, v.endTime]
            } else {
              this.system_timeForm['checked' + (v.weekday - 1)] = true
              this.system_timeForm['startAndEndTime' + (v.weekday - 1)] = [v.startTime, v.endTime]
            }
          }
        })
      }/*  else {
        Object.assign(this.system_timeForm, this.acdTimeForm)// 拷贝策略的时间
      } */
      this.dialogServiceTime = true
    },
    changeSwitch(data) {
      if (data === 1) {
        if (!this.cacheAcd.acdBizResets || this.cacheAcd.acdBizResets.length === 0) {
          const newTime = {}
          Object.assign(newTime, this.resetTime)
          this.cacheAcd.acdBizResets.push(newTime)
        }
        this.isShow = true
      } else {
        this.isShow = false
      }
    },
    comfirmBiz() {
      const weekDayTimes = this.convertTime(this.system_timeForm)
      for (let i = 0; i < this.cacheAcd.acdBizs.length; i++) {
        if (this.cacheAcd.acdBizs[i].id === this.curDialogBizId) {
          this.cacheAcd.acdBizs[i].excludeHoliday = this.system_timeForm.excludeHoliday
          this.cacheAcd.acdBizs[i].extimeServiceType = this.system_timeForm.extimeServiceType
          this.cacheAcd.acdBizs[i].extimeServiceWords = this.system_timeForm.extimeServiceWords
          this.cacheAcd.acdBizs[i].bizTimes = weekDayTimes
          break
        }
      }
      this.dialogServiceTime = false
    },
    /**
     * 转换时间
     */
    convertTime(sourceForm) {
      const weekDayTimes = []
      for (let i = 1; i < 8; i++) {
        if (!sourceForm['checked' + i] || sourceForm['startAndEndTime' + i].length === 0) {
          continue
        }
        const weekDayTime = {}
        if (sourceForm['checked' + i]) {
          if (i === 7) {
            if (sourceForm['startAndEndTime' + i]) {
              weekDayTime.weekday = 1
            }
          } else {
            if (sourceForm['startAndEndTime' + i]) {
              weekDayTime.weekday = i + 1
            }
          }
          weekDayTime.startTime = sourceForm['startAndEndTime' + i][0]
          weekDayTime.endTime = sourceForm['startAndEndTime' + i][1]
          weekDayTime.type = 1
          weekDayTimes.push(weekDayTime)
        }
      }
      return weekDayTimes
    },
    addBiz() {
      if (this.cacheAcd.acdBizs && this.cacheAcd.acdBizs.length >= 10) {
        return
      }
      const random = Math.ceil(Math.random() * 10000000)
      getRandomUUID({ random: random }).then(res => {
        this.addBizLoadingLing = true
        if (res.code === 2000) {
          const newRandomId = res.data
          const newBiz = JSON.parse(JSON.stringify(this.blankBiz))
          newBiz.acdId = this.cacheAcd.id
          newBiz.id = newRandomId
          const tempTime = {}
          Object.assign(tempTime, this.acdTimeForm)// 拷贝策略的时间
          newBiz.bizTimes = this.convertTime(tempTime)
          newBiz.excludeHoliday = tempTime.excludeHoliday
          newBiz.extimeServiceType = tempTime.extimeServiceType
          newBiz.extimeServiceWords = tempTime.extimeServiceWords
          this.cacheAcd.acdBizs.push(newBiz)
          this.forceInput()
        }
        this.addBizLoadingLing = false
        // console.log(this.cacheAcd.acdBizs)
      })
    },
    deleteBiz(index) {
      this.cacheAcd.acdBizs.splice(index, 1)
      this.forceInput()
    },
    addResetTime(index) {
      if (this.cacheAcd.acdBizResets.length >= 3) {
        return
      }
      const newTime = {}
      Object.assign(newTime, this.resetTime)
      this.cacheAcd.acdBizResets.push(newTime)
      this.forceInput()
    },
    deleteResetTime(index) {
      this.cacheAcd.acdBizResets.splice(index, 1)
      this.forceInput()
    },
    nextStep() {
      // 业务开启时，业务名称不能为空
      if (this.cacheAcd.enableBiz === 1) {
        if (this.cacheAcd.acdBizs.length === 0) {
          this.$message.error('业务不能为空')
          return
        }
        for (let i = 0; i < this.cacheAcd.acdBizs.length; i++) {
          if (!this.cacheAcd.acdBizs[i].bizName) {
            this.$message.error('业务名不能为空')
            return
          }
          if (this.cacheAcd.acdBizs[i].skillGroupIds.length === 0) {
            this.$message.error('业务技能组不能为空')
            return
          }
        }
      }
      this.$store.commit('user/setAcdStepIndex', { acdStepIndex: 3 })
    },
    cancel() {
      this.$store.commit('user/setAcdPageIndex', { acdPageIndex: 1 })
      this.$store.commit('user/setAcdStepIndex', { acdStepIndex: 1 })
    },
    lastStep() {
      this.$store.commit('user/setAcdStepIndex', { acdStepIndex: 1 })
    }
  }
}
</script>
